import { NavigationSubItem } from "../navigation-item"

export class VeScaleLockSubItem extends NavigationSubItem {
  readonly id = "vescale"
  readonly label = "Lock"
  readonly href = "/lock"
  readonly iconName = "lock-icon"
  readonly isExternal = false
  readonly tabs = []
}
